import cyc from '../../assets/webp/fromJPG/AlgaeTheme/ConnectYourCare.webp';
import makerDAO from '../../assets/webp/fromJPG/AlgaeTheme/makerDAO.webp';
import veryfiID from '../../assets/webp/fromJPG/AlgaeTheme/VeryfiID.webp';
import zbay from '../../assets/webp/fromJPG/AlgaeTheme/Zbay.webp';
export const images = [makerDAO, cyc, zbay, veryfiID];
export const data = [
  {
    company: 'makerDAO',
    title: 'The company behind DAI',
    link: '/case-studies/makerdao/',
    image: makerDAO,
  },
  {
    company: 'ConnectYourCare',
    title: 'Online platform for benefit brokers',
    link: '/case-studies/connectyourcare/',
    image: cyc,
  },
  {
    company: 'Zbay',
    title: 'A private inbox, wallet, and marketplace all in one',
    link: '/case-studies/zbay-a-private-inbox-wallet-and-marketplace-all-in-one/',
    image: zbay,
  },
  {
    company: 'VeryfiID',
    title: 'Discovery Workshop for an identity verification',
    link: '/case-studies/verifiid-mvp/',
    image: veryfiID,
  },
];
